import { useAxiosRequest } from "api/axiosRequest";
import { BASE_URL } from "api/url_helper";
import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";

export interface addVesselLogParams{
    vesselImo: string
    tagId: string
    comment: string
}
export function useAddVesselLog(){
    const [isAddCommentsLoading, setIsAddCommentsLoading] = useState<boolean>(false)
    const request = useAxiosRequest()
    const createVesselLog = async (log: addVesselLogParams) => {
        try{
            setIsAddCommentsLoading(true)
            await request<any, any>({
                url: `${BASE_URL}/prevetting/logs`,
                method: "POST",
                data: log
            })
        } catch(err: unknown){
            const message = "Unable to add vessel log"
            console.error(message, err)
            if (axios.isAxiosError(err)){
                toast.warn(message, {
                    position: "bottom-right",
                    autoClose: 8000
                })
            }
        } finally{
            setIsAddCommentsLoading(false)
        }
    }
    return {createVesselLog, isAddCommentsLoading}
}   